
import { Component, Vue } from "vue-property-decorator";
import Overview from "../components/Overview.vue";
import Leaderboard from "../components/Base/LeaderboardTable.vue";
import GamesTable from "../components/Games/GamesTable.vue";
import ImageSelector from "../components/Base/ImageSelector.vue";
import { Game } from "@/models/Game";

@Component({
  components: {
    Overview,
    Leaderboard,
    GamesTable,
    ImageSelector,
  },
})
class Recent extends Vue {
  selectedValue = "";
  leaderBoardTitle = "";

  get selectedGameValue(): string {
    return this.selectedValue;
  }

  get getGameList(): Game[] {
    return this.$store.state.gameStore.games;
  }

  created(): void {
    this.$store.commit("authenication/setNavTab", 1);
  }

  handleGameSelection(row: any): void {
    this.selectedValue = row.key;
    this.leaderBoardTitle = row.admin_name;
  }
}

export default Recent;
